var map = {
	"./Icon-01.svg": "fda4",
	"./Icon-13.svg": "270b",
	"./Icon-16.svg": "bfac",
	"./company_address-18.svg": "417f",
	"./company_associated-companies.svg": "7590",
	"./company_company-name.svg": "3590",
	"./company_company-number.svg": "8b0e",
	"./company_dissolution-date.svg": "30e4",
	"./company_email-17.svg": "843a",
	"./company_inc-date.svg": "985c",
	"./company_phone-16.svg": "5c02",
	"./domain.svg": "803b",
	"./enterprise.svg": "4f78",
	"./event.svg": "14d4",
	"./file.svg": "6be4",
	"./hobby.svg": "b7fe",
	"./icon_active.svg": "cd58",
	"./icon_keyfact.svg": "df69",
	"./icon_monitor.svg": "93c2",
	"./icon_newspaper.svg": "e993",
	"./icon_passive.svg": "f626",
	"./icon_social.svg": "c72d",
	"./individual_address-08.svg": "6048",
	"./individual_associated-person.svg": "0947",
	"./individual_dateofbirth.svg": "7b17",
	"./individual_education.svg": "cedf",
	"./individual_email-07.svg": "fbcb",
	"./individual_employement.svg": "a9df",
	"./individual_name.svg": "563f",
	"./individual_nationality.svg": "add8",
	"./individual_phone-06.svg": "3b1d",
	"./individual_usernames.svg": "0895",
	"./search-engine.svg": "4587",
	"./search.svg": "ec95",
	"./search_mono.svg": "0e3b",
	"./transparent_square.svg": "f390",
	"./university.svg": "b3cd",
	"./url.svg": "e3a7",
	"./website.svg": "63ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb23";